module.exports = __webpack_public_path__ + "assets/skip-forward.png?f8564915df11b3077fd035d88d019b07";